import React from 'react';
import { motion } from 'framer-motion';

const CategoryNavigation = ({ categories, activeCategory, setActiveCategory }) => {
  const getActiveCategoryData = () => {
    return categories.find(c => c.id === activeCategory);
  };

  const getDisplayTitle = (category) => {
    if (category.id === 'videos') {
      return 'Videos';
    }
    return `${category.name} Elevators`;
  };

  const getCategoryIcon = (categoryId) => {
    const icons = {
      all: 'th',
      interior: 'home',
      doors: 'door-open',
      controls: 'sliders-h',
      ceiling: 'crown',
      lighting: 'lightbulb',
      design: 'palette',
      installation: 'tools',
      safety: 'shield-alt',
      videos: 'play-circle'
    };
    return icons[categoryId] || 'th';
  };

  return (
    <>
      <div style={styles.navigation}>
        {categories.map(category => (
          <motion.button
            key={category.id}
            style={{
              ...styles.categoryButton,
              borderColor: activeCategory === category.id ? category.color : 'transparent',
              boxShadow: activeCategory === category.id ? `0 0 15px ${category.color}40` : 'none',
              backgroundColor: activeCategory === category.id ? `${category.color}10` : '#fff'
            }}
            onClick={() => setActiveCategory(category.id)}
            whileHover={{ 
              scale: 1.05, 
              boxShadow: `0 5px 15px rgba(0, 0, 0, 0.2), 0 0 0 2px ${category.color}` 
            }}
            whileTap={{ scale: 0.95 }}
          >
            <i 
              className={`fas fa-${getCategoryIcon(category.id)}`} 
              style={{ 
                marginRight: '8px', 
                color: activeCategory === category.id ? category.color : '#666' 
              }}
            />
            {category.name}
          </motion.button>
        ))}
      </div>

      <motion.div 
        key={activeCategory + "-description"}
        style={styles.description}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.4 }}
      >
        <h2 style={{ 
          ...styles.descriptionTitle, 
          color: getActiveCategoryData().color 
        }}>
          <i 
            className={`fas fa-${getCategoryIcon(activeCategory)}`} 
            style={{ marginRight: '12px' }}
          />
          {getDisplayTitle(getActiveCategoryData())}
        </h2>
        <p style={styles.descriptionText}>
          {getActiveCategoryData().description}
        </p>
        
        {/* Media count display */}
        <div style={styles.mediaCount}>
          <span style={{ color: getActiveCategoryData().color }}>
            {getActiveCategoryData().images.length} 
            {activeCategory === 'videos' ? ' Videos' : ' Images'}
          </span>
        </div>
      </motion.div>
    </>
  );
};

const styles = {
  navigation: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '12px',
    marginBottom: '30px',
  },
  categoryButton: {
    backgroundColor: '#fff',
    border: '2px solid transparent',
    borderRadius: '30px',
    padding: '12px 20px',
    fontSize: '1rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    color: '#333',
    boxShadow: '0 3px 10px rgba(0, 0, 0, 0.1)',
    fontFamily: '\'Montserrat\', sans-serif',
    display: 'flex',
    alignItems: 'center',
  },
  description: {
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto 40px',
    background: 'linear-gradient(145deg, #ffffff, #f5f8ff)',
    padding: '25px',
    borderRadius: '8px',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.05)',
  },
  descriptionTitle: {
    marginTop: 0,
    fontSize: '1.8rem',
    marginBottom: '15px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  descriptionText: {
    fontSize: '1.1rem',
    lineHeight: '1.6',
    color: '#555',
    marginBottom: '15px',
  },
  mediaCount: {
    fontSize: '0.9rem',
    fontWeight: '600',
    opacity: 0.8,
  }
};

export default CategoryNavigation;